import { getFirestore, collection, query, where, orderBy, getDocs, getDoc, doc } from "firebase/firestore";
import { firebaseApp } from "../../firebase.js"; // adjust based on where you init Firebase

const db = getFirestore(firebaseApp);

function shuffleArray(array) {
  return array
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);
}

const getUserByRef = async (userRef) => {
  if (!userRef) return null;
  const userSnap = await getDoc(userRef);
  return userSnap.exists() ? { id: userSnap.id, ...userSnap.data() } : null;
};

export const getApprovedServicesWithUser = async () => {
  const q = query(
    collection(db, "services"),
    where("status", "==", "Active"),
    orderBy("timePosted", "desc")
  );

  const snapshot = await getDocs(q);
  const services = await Promise.all(
    snapshot.docs.map(async (docSnap) => {
      const servicesData = docSnap.data();
      const user = await getUserByRef(servicesData.servicesUserUID);
      return {
        id: docSnap.id,
        ...servicesData,
        servicesUserUID: user, // add full user data
      };
    })
  );

  return services;
}

export const getServiceByID = async (id) => {
  try {
    const docRef = doc(db, "services", id);      // <-- Use modular doc() here
    const docSnap = await getDoc(docRef);     // <-- Use getDoc()

    if (!docSnap.exists()) return null;       // <-- call exists() as a method

    const servicesData = docSnap.data();
    const user = await getUserByRef(servicesData.servicesUserUID);
    return {
      id: docSnap.id,
      ...servicesData,
      servicesUserUID: user
    };
  } catch (error) {
    console.error("Error fetching rental by ID:", error);
    return null;
  }
};

export const getRandomApprovedServicesWithUser = async () => {
  const q = query(
    collection(db, "services"),
    where("status", "==", "Active"),
    orderBy("timePosted", "desc")
  );

  const snapshot = await getDocs(q);

  const shuffledDocs = shuffleArray(snapshot.docs).slice(0, 5);

  const services = await Promise.all(
    shuffledDocs.map(async (docSnap) => {
      const servicesData = docSnap.data();
      const user = await getUserByRef(servicesData.servicesUserUID);
      return {
        id: docSnap.id,
        ...servicesData,
        servicesUserUID: user,
      };
    })
  );

  return services;
};

export const getNextloopServices = async () => {
  // Step 1: get active services
  const q = query(
    collection(db, "services"),
    where("status", "==", "Active"),
    orderBy("timePosted", "desc")
  );

  const snapshot = await getDocs(q);

  // Step 3: map services + fetch user profile
  const services = await Promise.all(
    snapshot.docs.map(async (docSnap) => {
      const servicesData = docSnap.data();
      if (servicesData.servicesUserUID) {
        if (servicesData.servicesUserUID.path == "Users/7uWoK40LM9MEdjfB5TYVmdm5uU62") {
          const user = await getUserByRef(servicesData.servicesUserUID);
          return {
            id: docSnap.id,
            ...servicesData,
            servicesUserUID: user
          };
        }
      }
      return null;
    })
  );

  return services.filter(Boolean);
};

export const getReview = async (id) => {
  try {
    const reviewsRef = collection(db, "services", id, "reviews");
    const querySnapshot = await getDocs(reviewsRef);

    if (querySnapshot.empty) return [];

    const reviews = querySnapshot.docs.map((docSnap) => ({
      id: docSnap.id,
      ...docSnap.data(),
    }));

    return reviews;
  } catch (error) {
    console.error("Error fetching reviews:", error);
    return [];
  }
}